document.addEventListener('DOMContentLoaded', function () {
  const loadMoreButton = document.getElementById('load-more');
  const productGrid = document.getElementById('product-grid');
  const productsPerPage = 16; // Adjust this if the default number changes
  const initialProductCount = productGrid.children.length; // Count the initially loaded products

  // Hide the Load More button if the initial product count is less than or equal to the products per page
  if (initialProductCount <= productsPerPage) {
    loadMoreButton.style.display = 'none';
  }

  if (loadMoreButton && productGrid) {
    loadMoreButton.addEventListener('click', function () {
      let nextPage = parseInt(productGrid.getAttribute('data-page')) + 1;
      const url = `${window.location.pathname}?page=${nextPage}`;

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll('#product-grid > li'); // Adjust the selector to target product items

          newProducts.forEach(product => {
            productGrid.appendChild(product);
          });

          productGrid.setAttribute('data-page', nextPage);

          // If no valid product items were loaded or less than 6 items were loaded, hide the button
          if (newProducts.length === 0 || newProducts.length < 6) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch(error => console.error('Error loading more products:', error));
    });
  }
});
